import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "formContainer",
  class: "container page-container"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-12" }
const _hoisted_4 = { class: "font-lead" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12 col-lg-12" }
const _hoisted_7 = {
  class: "tabnav",
  role: "tablist",
  id: "tabs"
}
const _hoisted_8 = {
  "aria-controls": "tabpanel-landing",
  id: "tab-landing",
  class: "tabnav-item",
  role: "tab",
  "aria-selected": "true"
}
const _hoisted_9 = {
  class: "tabnav-panel",
  "aria-hidden": "false",
  role: "tabpanel",
  tabindex: "0",
  id: "tabpanel-landing",
  "aria-labelledby": "tab-landing"
}
const _hoisted_10 = {
  key: 0,
  class: "alert alert-warning",
  role: "alert",
  "aria-atomic": "true"
}
const _hoisted_11 = { class: "alert-body" }
const _hoisted_12 = { class: "alert-heading" }
const _hoisted_13 = { class: "alert-text" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode()
const _hoisted_15 = {
  "aria-controls": "tabpanel_og_oplysninger",
  id: "tab_og_oplysninger",
  class: "tabnav-item",
  role: "tab",
  "aria-selected": "false"
}
const _hoisted_16 = {
  class: "tabnav-panel",
  "aria-hidden": "true",
  role: "tabpanel",
  tabindex: 2,
  id: "tabpanel_og_oplysninger",
  "aria-labelledby": "tab_og_oplysninger"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KlarTekst = _resolveComponent("KlarTekst")!
  const _component_RichTekst = _resolveComponent("RichTekst")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Opsummering = _resolveComponent("Opsummering")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", null, [
          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.overskrift' }, null, 8, ["tekstNoegle"])
        ]),
        _createElementVNode("p", _hoisted_4, [
          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.underoverskrift' }, null, 8, ["tekstNoegle"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", _hoisted_8, [
            _createElementVNode("span", null, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.introduktion.tabnavn' }, null, 8, ["tekstNoegle"])
            ])
          ]),
          _createElementVNode("section", _hoisted_9, [
            _createElementVNode("h2", null, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.introduktion.overskrift' }, null, 8, ["tekstNoegle"])
            ]),
            (_ctx.existingTGBlanketId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("p", _hoisted_12, [
                      _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.introduktion.advarsel.eksisterende-tg-blanket.overskrift' }, null, 8, ["tekstNoegle"])
                    ]),
                    _createElementVNode("p", _hoisted_13, [
                      _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.introduktion.advarsel.eksisterende-tg-blanket.beskrivelse' }, null, 8, ["tekstNoegle"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("p", null, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.introduktion.beskrivelse-1' }, null, 8, ["tekstNoegle"]),
              _hoisted_14,
              _createElementVNode("a", {
                href: "javascript:void(0)",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openOgInformationTab()))
              }, [
                _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.introduktion.ordregivers-oplysninger.link.tekst' }, null, 8, ["tekstNoegle"])
              ])
            ]),
            _createVNode(_component_RichTekst, { tekstNoegle: 'tco.blanket.tg-blanket.introduktion.beskrivelse-2' }, null, 8, ["tekstNoegle"]),
            (_ctx.ogInformation && !_ctx.unknownOgBlanketId && !_ctx.existingTGBlanketId)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: '/blanketTG?og_id=' + _ctx.ogBlanketId + '&product_id=' + _ctx.ogInformation.natureCode,
                  class: "button button-primary",
                  id: "start-blanket-button"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.introduktion.start-blanket' }, null, 8, ["tekstNoegle"])
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (_ctx.ogInformation && !_ctx.unknownOgBlanketId && _ctx.existingTGBlanketId)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  to: "/overblikTG",
                  id: "mine-tilbud-button"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.introduktion.mine-tilbud' }, null, 8, ["tekstNoegle"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", _hoisted_15, [
            _createElementVNode("span", null, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.ordregivers-oplysninger.tabnavn' }, null, 8, ["tekstNoegle"])
            ])
          ]),
          _createElementVNode("section", _hoisted_16, [
            (!_ctx.ogBlanketId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.udbud-valg-mangler.beskrivelse' }, null, 8, ["tekstNoegle"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.ogBlanketId)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_18, [
                  _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.opsummering-og-oplysninger.beskrivelse' }, null, 8, ["tekstNoegle"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.ogInformation)
              ? (_openBlock(), _createBlock(_component_Opsummering, {
                  key: 2,
                  formular: _ctx.ogInformation,
                  editable: false
                }, null, 8, ["formular"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}